import { render, staticRenderFns } from "./ExchangeApplyPopup.vue?vue&type=template&id=ccd9cf48&"
import script from "./ExchangeApplyPopup.vue?vue&type=script&lang=ts&"
export * from "./ExchangeApplyPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports